import styled from 'styled-components';

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
